export const formActions = {
	cancel: "Close",
	create: "Complete registration",
	save: "Save changes",
	validationError: {
		title: "Form validation failed",
		description: "Please fix {{count}} error(s) in the following tabs: {{tabs}}",
	},
};
